const navData = [
  { title: "Home", to: "/" },
  { title: "Coffee", to: "/collections/coffee-blends" },
  { title: "About us", to: "/about-us" },
];
export default navData;
